module.exports = __webpack_public_path__ + "static/img/logo.d0c2ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/logo.png
// module id = xYTw
// module chunks = 14